import { render, staticRenderFns } from "./AppModalNotification.vue?vue&type=template&id=2b6cd1e8&"
import script from "./AppModalNotification.vue?vue&type=script&lang=js&"
export * from "./AppModalNotification.vue?vue&type=script&lang=js&"
import style0 from "./AppModalNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports